import { ACCOUNT_API_UNLOCK } from 'apiRoutes';
import useSubmit, { POST } from 'hooks/useSubmit';
import { FunctionComponent } from 'react';
import { MontelAccount } from 'domain/account/interfaces';
import { ConfirmationModal } from 'components/common/ConfirmationModal/ConfirmationModal';

interface ReopenAccountModalProps {
	user: MontelAccount | undefined;
	onSuccess: (userId: string) => void;
	setModalOpen: (open: boolean) => void;
	isOpen: boolean;
}

export const ReopenAccountModal: FunctionComponent<ReopenAccountModalProps> = ({
	user,
	onSuccess,
	setModalOpen,
	isOpen,
}) => {
	if (!user) {
		return null;
	}

	const [reopenAccountPostData, reopenAccountStatus] = useSubmit(
		`${ACCOUNT_API_UNLOCK}`,
		POST,
		{
			messageOnError: 'An error occured, please try again!',
			messageOnSuccess: `Account belonging to ${user.firstName} ${user.lastName} was reopened`,
			showApiError: true,
		},
	);

	const onReopenAccount = async (comment?: string) => {
		const result = await reopenAccountPostData({
			accountId: user.id,
			comment,
		});

		if (result.success) {
			onSuccess(user.id);
			setModalOpen(false);
		}
	};

	return (
		<ConfirmationModal
			showModal={isOpen}
			setShowModal={setModalOpen}
			onSubmit={onReopenAccount}
			header={'Reopen Account'}
			text={`Are you sure you want to reopen the account belonging to ${user.firstName} ${user.lastName}?`}
			buttonText={'Reopen'}
			loadingStatus={reopenAccountStatus}
		/>
	);
};
